import { sleep } from 'component_utils/utils';
import Date, { DATE_TIME } from 'components/Date';
import ProcessingButton from 'components/ProcessingButton';
import React, { useCallback } from 'react'
import { FaCopy } from 'react-icons/fa';
import { Badge, Table } from 'reactstrap';
import { useApi, useApiLoader } from 'utils/API';
import Translation from 'utils/Language/Translation';
import { alert, prompt } from 'utils/Prompts';

export default ({ userId }: any) => {
  const api = useApi()
  const { data: keys, reload } = useApiLoader(
    useCallback(api => api.users.apikeys.getAll(userId), [userId]),
    [],
    true
  )
  return (
    <>
      <div className="nested-flex-container">
        <Table striped>
          <tbody>
            {keys.map(it => (
              <tr key={it.id}>
                <td className='w-80'><Badge>{it.label}</Badge></td>
                <td className='w-20'><Date val={it.lastUsedAt} format={DATE_TIME}/></td>
                <td className='w-0'>
                  <ProcessingButton 
                    color='danger'
                    className='py-0'
                    onClick={async () => {
                      await api.users.apikeys.deleteKey(userId, it.id)
                      reload()
                    }}
                  >
                    <Translation name="T.misc.delete"/>
                  </ProcessingButton>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <ProcessingButton block color='primary' onClick={async () => {
          const label = await prompt(
            <Translation name="T.hints.apiLabel"/>, ''
          )

          if (label === null) {
            return
          }

          const apiKey = await api.users.apikeys.createNew(userId, label)

          await alert(
            <Translation 
              name="T.misc.newApiKey" 
              params={{ 
                key: (
                  <b style={{ wordBreak: 'break-all' }}>
                    {apiKey.key}
                    {' '}
                    <ProcessingButton color="link" className='p-0' onClick={async () => {
                      navigator.clipboard.writeText(apiKey.key)
                      await sleep(100)
                    }}>
                      <FaCopy/>
                    </ProcessingButton>
                  </b>
                ) 
              }} 
            />
          )
          reload()
        }}>
          <Translation name="T.misc.add"/>
        </ProcessingButton>
      </div>
    </>
  );
}